module.exports = __webpack_public_path__ + "img/main.0040bb0a.png";